const ICON_SIDEBAR_OPEN = ({ color = "#000", strokeWidth = 1, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 10 10"
    fill="none"
    {...props}
  >
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={0.7}
      d="M2.947 7.521.35 5.001l2.597-2.522"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
    <path
      fill="none"
      stroke={color}
      strokeLinecap="round"
      strokeWidth={0.7}
      d="M5.595 5H.351M9.65 9.65V.35"
      style={{
        paintOrder: "markers fill stroke",
      }}
    />
  </svg>
);

export default ICON_SIDEBAR_OPEN;
